import { useSessionStorageState } from 'ahooks';

export default () => {
  const [searchPreCollect, setSearchPreCollect] = useSessionStorageState<any>(
    'use-local-storage-state-search-pre-collect',
    { defaultValue: { label: '未分类', value: "-1" } }
  );
  return {
    searchPreCollect,
    setSearchPreCollect
  }
}
